import {
  LayoutDashboard,
  Workflow,
  TrendingUp,
  PiggyBank,
  ClipboardCheck,
  ClipboardPen,
  Cpu,
  FileText,
  Bell,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean; // exact-match for the index route
}

/**
 * The 8 primary screens (CLAUDE.md §11.1). Order + labels match the route list.
 * TODO(spec): confirm exact nav copy + icon choices against the shipped screenshots.
 */
export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', label: 'Cockpit', icon: LayoutDashboard, end: true },
  { to: '/balance', label: 'Energy Balance', icon: Workflow },
  { to: '/trends', label: 'Trends', icon: TrendingUp },
  { to: '/savings', label: 'M&V & Savings', icon: PiggyBank },
  { to: '/iso50001', label: 'ISO 50001', icon: ClipboardCheck },
  { to: '/assets', label: 'Assets & Tags', icon: Cpu },
  { to: '/capture', label: 'Field Capture', icon: ClipboardPen },
  { to: '/reports', label: 'Reports', icon: FileText },
  { to: '/alerts', label: 'Alerts', icon: Bell },
] as const;
